import React from 'react';
import'./DashboardHome.css';

const DashboardHome = () => {
    return (
        
        <div className=' dhome-bg my-4 p-4 w-75 rounded mx-auto justify-content-center align-items-center'>
            <h1>Welcome to Dashboard</h1>
            <img className='img-fluid' src='https://images2.imgbox.com/1a/7a/0QCFyZL6_o.png' alt="" />

        
        </div>
    );
};

export default DashboardHome;